import React from 'react';
import styled, { css } from 'styled-components';
import { CARD_MIN_COLUMN_WIDTH } from '~/components/template/EventTimelineV2/components/BaseEventCard';
import { GridLayout } from '~/graphql/types';
import { BLUR_STYLES } from '../../Data/styles';
import arrayToCss from '~/util/arrayToCss';
import type { SystemSize } from '~/theme/System/tokens';

export type Props = Omit<GridLayout, '__typename'> & {
  dataTestId?: string;
};

const Grid: React.FCC<Props> = ({
  dataTestId,
  children,
  css,
  margin,
  padding,
  gap,
  blurred,
}) => (
  <Container
    data-testid={dataTestId}
    $blurred={blurred || false}
    $padding={padding ?? undefined}
    $margin={margin ?? undefined}
    $gap={gap ?? undefined}
    $css={css || ''}
  >
    {children}
  </Container>
);

const Container = styled.div<{
  $blurred: boolean;
  $gap?: SystemSize;
  $padding?: Array<SystemSize | null>;
  $margin?: Array<SystemSize | null>;
  $css: string;
}>(
  ({
    theme,
    $gap,
    $padding = [null, null, null, null],
    $margin = [null, null, null, null],
    $blurred,
    $css,
  }) => css`
    display: grid;
    width: 100%;
    padding: ${arrayToCss($padding, theme)};
    margin: ${arrayToCss($margin, theme)};
    gap: ${$gap ? theme.space($gap) : 'unset'};

    grid-template-columns: repeat(
      auto-fit,
      minmax(${CARD_MIN_COLUMN_WIDTH}px, 1fr)
    );

    ${$blurred && BLUR_STYLES};

    ${$css &&
    css`
      ${$css}
    `}
  `,
);

export default Grid;
